import { useState, useEffect, useCallback } from 'react';
import PageShell from '../../components/feature/PageShell';
import PageHero from '../../components/feature/PageHero';

const reviews = [
  {
    name: 'Marisol Gh',
    avatar: 'M',
    rating: 5,
    text: 'Excelente servicio y atención. El equipo es muy profesional y me hicieron sentir cómoda desde la primera consulta. Mi sonrisa ha cambiado completamente.',
    service: 'Blanqueamiento dental',
    date: 'Marzo 2025',
    avatarBg: 'from-[#3A86FF] to-[#0A2540]',
  },
  {
    name: 'Lore Naba',
    avatar: 'L',
    rating: 5,
    text: 'Muy profesional el trato y los resultados superaron mis expectativas. La clínica es muy moderna y limpia. Definitivamente regresaré para más tratamientos.',
    service: 'Rehabilitación dental',
    date: 'Febrero 2025',
    avatarBg: 'from-emerald-400 to-emerald-700',
  },
  {
    name: 'Juan Fernando',
    avatar: 'JF',
    rating: 5,
    text: 'Recomiendo ampliamente la clínica. Llevaba años postergando mi tratamiento por miedo, pero aquí me trataron con mucha paciencia y cuidado. ¡Excelente lugar!',
    service: 'Ortodoncia',
    date: 'Enero 2025',
    avatarBg: 'from-violet-400 to-violet-700',
  },
  {
    name: 'Ana Laura P.',
    avatar: 'AL',
    rating: 5,
    text: 'Me realizaron una limpieza profunda y coronas. El trabajo quedó perfecto y el dolor fue mínimo. La Dra. es increíble, muy amable y explicó todo el proceso.',
    service: 'Prótesis y coronas',
    date: 'Diciembre 2024',
    avatarBg: 'from-amber-400 to-amber-600',
  },
  {
    name: 'Carlos Mendoza',
    avatar: 'CM',
    rating: 5,
    text: 'Las instalaciones son modernas y muy limpias. El personal es atento y profesional. El resultado de mi tratamiento fue excelente. 100% recomendado.',
    service: 'Estética dental',
    date: 'Noviembre 2024',
    avatarBg: 'from-rose-400 to-rose-700',
  },
  {
    name: 'Patricia Soto',
    avatar: 'PS',
    rating: 5,
    text: 'Vine con mucho miedo por mi primer implante. El equipo fue increíblemente amable y profesional. El procedimiento fue mucho más fácil de lo esperado y el resultado es increíble.',
    service: 'Implante dental',
    date: 'Octubre 2024',
    avatarBg: 'from-teal-400 to-teal-700',
  },
  {
    name: 'Roberto Díaz',
    avatar: 'RD',
    rating: 5,
    text: 'Excelente experiencia desde el primer momento. Precios justos, trato humano y resultados de primera. La Dra. explica todo con detalle y hace sentir cómodo al paciente.',
    service: 'Limpieza y prevención',
    date: 'Septiembre 2024',
    avatarBg: 'from-indigo-400 to-indigo-700',
  },
  {
    name: 'Gabriela Torres',
    avatar: 'GT',
    rating: 5,
    text: 'Llevé a toda mi familia y todos salimos encantados. Los niños no lloraron y los adultos quedamos muy satisfechos. Sin duda el mejor consultorio dental de la zona.',
    service: 'Atención familiar',
    date: 'Agosto 2024',
    avatarBg: 'from-pink-400 to-pink-700',
  },
];

const VISIBLE = 3;

function ReviewCarousel() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const total = reviews.length;

  const go = useCallback(
    (next: number) => {
      if (animating) return;
      setAnimating(true);
      setTimeout(() => {
        setCurrent((next + total) % total);
        setAnimating(false);
      }, 300);
    },
    [animating, total]
  );

  const prev = () => go(current - 1);
  const next = () => go(current + 1);

  useEffect(() => {
    const id = setInterval(() => go(current + 1), 6000);
    return () => clearInterval(id);
  }, [current, go]);

  const indices = Array.from({ length: VISIBLE }, (_, i) => (current + i) % total);

  return (
    <div className="relative">
      <div
        className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-opacity duration-300 ${
          animating ? 'opacity-0' : 'opacity-100'
        }`}
      >
        {indices.map((revIdx, pos) => {
          const rev = reviews[revIdx];
          const isCenter = pos === 1;
          return (
            <div
              key={`${revIdx}-${pos}`}
              className={`relative rounded-3xl p-7 border flex flex-col transition-all duration-300 ${
                isCenter
                  ? 'bg-[#0A2540] border-[#3A86FF]/30 scale-105'
                  : 'bg-white border-gray-100'
              }`}
            >
              <div className={`absolute top-6 right-6 opacity-20 ${isCenter ? 'text-white' : 'text-[#3A86FF]'}`}>
                <i className="ri-double-quotes-r text-4xl" />
              </div>
              <div className="flex gap-0.5 mb-4 items-center">
                {[...Array(rev.rating)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-yellow-400 text-sm" />
                ))}
              </div>
              <p className={`text-sm leading-relaxed mb-6 flex-1 ${isCenter ? 'text-white/80' : 'text-gray-500'}`}>
                "{rev.text}"
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br ${rev.avatarBg} text-white font-bold text-sm flex-shrink-0`}>
                    {rev.avatar}
                  </div>
                  <div>
                    <div className={`font-semibold text-sm ${isCenter ? 'text-white' : 'text-[#0A2540]'}`}>
                      {rev.name}
                    </div>
                    <div className={`text-xs ${isCenter ? 'text-[#3A86FF]' : 'text-gray-400'}`}>
                      {rev.service}
                    </div>
                  </div>
                </div>
                <div className={`text-xs ${isCenter ? 'text-white/40' : 'text-gray-300'}`}>{rev.date}</div>
              </div>
            </div>
          );
        })}
      </div>

      <button
        onClick={prev}
        className="absolute -left-5 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white border border-gray-200 hover:border-[#3A86FF] hover:bg-[#3A86FF] text-[#0A2540] hover:text-white rounded-full transition-all duration-200 cursor-pointer z-10"
      >
        <i className="ri-arrow-left-s-line text-xl" />
      </button>
      <button
        onClick={next}
        className="absolute -right-5 top-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-white border border-gray-200 hover:border-[#3A86FF] hover:bg-[#3A86FF] text-[#0A2540] hover:text-white rounded-full transition-all duration-200 cursor-pointer z-10"
      >
        <i className="ri-arrow-right-s-line text-xl" />
      </button>

      <div className="flex justify-center gap-2 mt-10">
        {reviews.map((_, i) => (
          <button
            key={i}
            onClick={() => go(i)}
            className={`rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? 'w-6 h-2 bg-[#3A86FF]' : 'w-2 h-2 bg-gray-200 hover:bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default function OpinionesPage() {
  return (
    <PageShell>
      {() => (
        <>
          <PageHero
            title="Opiniones y"
            highlight="Calificaciones"
            subtitle="Lo que dicen nuestros pacientes"
            bgImage="https://readdy.ai/api/search-image?query=happy%20smiling%20patient%20sitting%20in%20dental%20chair%20giving%20thumbs%20up%20satisfied%20dental%20treatment%20result%20happy%20patient%20dental%20clinic%20modern%20clean%20white%20room%20professional&width=1920&height=600&seq=opiniones-hero-001&orientation=landscape"
            breadcrumbs={[
              { label: 'Inicio', to: '/' },
              { label: 'Opiniones' },
            ]}
          />

          {/* Rating summary */}
          <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-6">
              <div className="text-center mb-16 scroll-animate">
                <div className="inline-flex items-center gap-4 bg-[#f7f9fc] rounded-2xl px-8 py-4 border border-gray-100 mb-10">
                  <div className="flex gap-0.5 items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-2xl" />
                    ))}
                  </div>
                  <span className="text-[#0A2540] font-extrabold text-3xl">5.0</span>
                  <div className="w-px h-8 bg-gray-200" />
                  <span className="text-gray-400">basado en 15 opiniones verificadas</span>
                </div>

                <div className="grid grid-cols-3 md:grid-cols-6 gap-4 max-w-3xl mx-auto">
                  {[
                    { label: 'Atención', val: 5.0 },
                    { label: 'Resultados', val: 5.0 },
                    { label: 'Limpieza', val: 5.0 },
                    { label: 'Precio', val: 4.9 },
                    { label: 'Puntualidad', val: 4.8 },
                    { label: 'Trato', val: 5.0 },
                  ].map((stat) => (
                    <div key={stat.label} className="bg-[#f7f9fc] rounded-2xl py-4 px-3 text-center border border-gray-100">
                      <div className="text-[#0A2540] font-bold text-xl">{stat.val}</div>
                      <div className="text-gray-400 text-xs mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <ReviewCarousel />
            </div>
          </section>

          {/* Google CTA */}
          <section className="py-20 bg-[#f7f9fc]">
            <div className="max-w-4xl mx-auto px-6 text-center scroll-animate">
              <div className="w-16 h-16 flex items-center justify-center bg-white rounded-2xl border border-gray-100 mx-auto mb-6">
                <i className="ri-google-line text-3xl text-[#3A86FF]" />
              </div>
              <h2 className="text-3xl font-extrabold text-[#0A2540] mb-4">
                ¿Ya nos visitaste? Deja tu reseña
              </h2>
              <p className="text-gray-500 mb-8 leading-relaxed">
                Tu opinión ayuda a más pacientes a encontrarnos y confiar en nosotros. Solo toma 2 minutos.
              </p>
              <a
                href="https://g.page/r/review"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#0A2540] hover:bg-[#0d3060] text-white px-8 py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-line" />
                </div>
                Dejar reseña en Google
              </a>
            </div>
          </section>
        </>
      )}
    </PageShell>
  );
}
